export const getIframeCommunication = (iframeName, iframeUrl) => {
    var _a;
    return (_a = document.querySelector(`body iframe[name=${iframeName}]`)) !== null && _a !== void 0 ? _a : createIFrameCommunication(iframeName, iframeUrl);
};
export const createIFrameCommunication = (iframeName, iframeUrl) => {
    const subject = document.querySelector('body');
    const html = `<iframe name="${iframeName}" src="${iframeUrl.toString()}" style="display: none; width: 0; height: 0;"></iframe>`;
    subject.insertAdjacentHTML('beforeend', html);
    return getIframeCommunication(iframeName, iframeUrl);
};
